import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rx-split-view',
  templateUrl: './rx-split-view.component.html',
  styleUrls: ['./rx-split-view.component.scss'],
})
export class RxSplitViewComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
